<template>
  <div class>
    <!-- added regions -->
    <transition-group name="fade" mode="in-out">
      <div
        class="card"
        v-for="(type, index) in addedRegionTypes"
        :key="'r-' + type"
      >
        <div class="card-body card-body-added" @click="editRegions(type)">
          <div class="card-links">
            <a href="#" @click.prevent>
              <small>Endre</small>
            </a>
            <a href="#" @click.prevent.stop="deleteRegion(type)">
              <small>Fjern</small>
            </a>
          </div>
          <h6>Område {{ index + 1 }}</h6>
          <span v-if="!norwaySelected"
            >{{ regionTypeName(type) }} {{ numberOfRegions(type) }}</span
          >
          <span v-if="norwaySelected" class="card-content">Hele Norge</span>
        </div>
      </div>
      <!-- Add more card -->
      <div class="card" v-if="showAddMoreArea" key="addMore">
        <div class="card-body card-body-added">
          <div class="card-links">
            <a
              href="#"
              @click.stop
              @click="deleteRegion('-1')"
              v-if="
                selectedRegionType && selectedRegionType.regionType !== '-1'
              "
            >
              <small>Fjern</small>
            </a>
          </div>

          <h6>Legg til område</h6>

          <select
            class="region-select"
            v-model="selectedRegionType"
            @change="regionTypeChanged"
          >
            <option
              v-for="type in filteredRegionTypes"
              class="one-bold"
              :key="type.regionType"
              :value="type"
              >{{ type.dropDownName }}</option
            >
          </select>

          <div
            v-if="
              selectedRegionType.regionType != '0' &&
                selectedRegionType.regionType != '-1'
            "
          >
            <fieldset class="boxes">
              <div class="selectAllMunicipalities">
                <input
                  type="checkbox"
                  v-model="allRegionsSelected"
                  id="allMunicipalitiesSelect"
                  @change="allRegionsChanged"
                />
                <label for="allMunicipalitiesSelect" class
                  >Alle {{ selectedRegionType.name }}</label
                >
              </div>
            </fieldset>
            <fieldset class="boxes">
              <ul v-if="visibleRegions.length > 1">
                <li v-for="region in visibleRegions" :key="region.regionId">
                  <label class="input-label" :for="region.regionName">
                    <input
                      type="checkbox"
                      :id="region.regionName"
                      :value="region"
                      v-model="selectedRegions"
                      @change="selectedRegionsChanged"
                    />
                    {{ region.regionName }}
                  </label>
                </li>
              </ul>
            </fieldset>
          </div>
        </div>
      </div>
    </transition-group>

    <transition name="fade" mode="">
      <!-- add more -->
      <div v-if="showAddMoreButton">
        <button type="button" @click="addMoreRegions" class="btn btn-nve btn-add-more">
          <span class="add-more-plus">+</span>
          <span>Legg til enda et varslingsområde</span>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AvalancheRegionSelector",
  props: {
    existingSubscription: {}
  },
  data() {
    return {
      SelectArea: "-1",
      selectedRegionType: {
        regionType: "-1",
        name: "Velg område",
        dropDownName: "Velg område"
      },
      selectedRegions: [],
      addedRegions: [],
      allRegionsSelected: false,
      enableShowArea: false,
      norwaySelected: false,
      regionTypes: [
        {
          regionType: "-1",
          name: "Velg område",
          dropDownName: "Velg område"
        },
        {
          regionType: "0",
          name: "Hele Norge",
          dropDownName: "Hele Norge"
        },
        {
          regionType: "A",
          name: "Varslingsregioner",
          dropDownName: "Varslingsregioner (Daglig varsling, alle faregrader)"
        },
        {
          regionType: "B",
          name: "Fylkesvarsler",
          dropDownName: "Fylkesvarsler (Bare ved faregrad 4 og 5)"
        }
      ]
    };
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      this.resetRegionTypeSelector();
      if (this.existingSubscription) {
        if (this.existingSubscription.isRegionNorway) {
          this.norwaySelected = true;
        }
        if (
          this.existingSubscription.avalancheRegions &&
          this.existingSubscription.avalancheRegions.length > 0
        ) {
          const avalancheRegions = this.$store.getters.avalancheRegions;
          for (
            let i = 0;
            i < avalancheRegions.length;
            i += 1
          ) {
            const region = avalancheRegions[i];
            if (
              this.existingSubscription.avalancheRegions.indexOf(
                region.regionId
              ) > -1
            ) {
              this.addedRegions.push(region);
            }
          }
        }
      }
      if(this.norwaySelected) this.enableShowArea = false;
    },
    getRegion(id) {
      if (!id) throw "No id specified for filtering regiontypes";
      if (!this.regionTypes || this.regionTypes.length === 0)
        throw "Regiontypes not initialized.";
      const findings = this.regionTypes.filter(
        r => r.regionType === id || r.regionType === id || r.name === id
      );
      if (findings && findings.length > 0) return findings[0];
      throw "No regiontype with name or id (" + id + ") culd be found.";
    },
    addMoreRegions() {
      this.addedRegions = this.addedRegions.concat(this.selectedRegions);
      this.enableShowArea = true;
      this.resetRegionTypeSelector();
      this.emitSelectedAndAddedRegions();
    },
    resetRegionTypeSelector() {
      this.selectedRegions = [];
      this.selectedRegionType = this.getRegion(this.SelectArea);
      if(this.norwaySelected) this.enableShowArea = false;
      this.enableShowArea = this.showAddMoreArea;

    },
    editRegions(regionType) {
      if (
        (this.selectedRegionType &&
          this.selectedRegionType.regionType != "-1") ||
        this.selectedRegionType.regionType != "0"
      ) {
        // update before delete
        this.addMoreRegions();
      }

      if (regionType === "0") {
        // hele norge
        this.deleteRegion(regionType);
        return;
      }

      this.prepareToEditRegion(regionType);
      // show add

      // changed!
    },
    prepareToEditRegion(regionType) {
      // get from added county
      const addedRegionType = this.addedRegions.filter(
        regiontype => regiontype.regionType === regionType
      )[0]; // remove from currently added
      this.addedRegionTypes.splice(
        this.addedRegionTypes.indexOf(addedRegionType)
      );

      // get municipalities from county
      const selected = this.addedRegions.filter(
        region => region.regionType === addedRegionType.regionType
      );

      // remove from added
      this.addedRegions = this.addedRegions.filter(
        region => region.regionType !== addedRegionType.regionType
      );

      // flag as selected
      this.selectedRegions = selected;
      this.selectedRegionType = this.regionTypes.filter(
        t => t.regionType === regionType
      )[0];
      this.allRegionsSelected =
        this.visibleRegions.length === this.selectedRegions.length;
    },
    deleteRegion(regionType) {
      if (regionType === "-1") {
        // delete current
        if (
          this.selectedRegionType &&
          this.selectedRegionType.regionType !== "0"
        ) {
          this.deleteRegion(this.selectedRegionType.regionType);
        }
        this.resetRegionTypeSelector();
        this.emitSelectedAndAddedRegions();
        return;
      }

      if (regionType === "0") {
        // hele norge
        this.clearAddedRegions();
        this.resetRegionTypeSelector();
      } else {
        for (let i = this.addedRegions.length - 1; i >= 0; i -= 1) {
          if (this.addedRegions[i].regionType === regionType) {
            this.addedRegions.splice(i, 1);
          }
        }
      }

      this.emitSelectedAndAddedRegions();
    },
    regionTypeChanged() {
      if(!this.selectedRegionType) {
        return;
      }
      if (this.selectedRegionType.regionType === "0") {
        // Hele norge
        this.norwaySelected = this.selectedRegionType.regionType === "0"; // hele norge
        this.addedMunicipalities = [];
      }

      this.selectedRegions = this.visibleRegions;
      this.allRegionsSelected =
        this.visibleRegions.length === this.selectedRegions.length;
      this.emitSelectedAndAddedRegions();
    },
    allRegionsChanged() {
      if (this.allRegionsSelected) {
        this.selectedRegions = this.visibleRegions;
      } else {
        this.selectedRegions = [];
      }
      this.emitSelectedAndAddedRegions();
    },
    regionTypeName(id) {
      if (id === "A") {
        return "Varslingsregioner";
      }
      if (id === "B") {
        return "Fylkesvarsler";
      }
      return id;
    },
    selectedRegionsChanged() {
      this.allRegionsSelected =
        this.visibleRegions.length === this.selectedRegions.length;
      this.emitSelectedAndAddedRegions();
    },
    emitSelectedAndAddedRegions() {
      this.$emit("regionAdded", this.addedRegions.concat(this.selectedRegions));
      this.$emit("norwaySelected", this.norwaySelected);
    },
    numberOfRegions(regionType) {
      let count = 0;
      for (let i = 0; i < this.addedRegions.length; i += 1) {
        const region = this.addedRegions[i];
        if (region.regionType === regionType) {
          count += 1;
        }
      }
      if (count < 1) {
        return "";
      } else if (count === 1) {
        return `(${
          this.addedRegions.filter(r => r.regionType === regionType)[0]
            .regionName
        })`;
      }

      return `(${count} regioner)`;
    },
    clearAddedRegions() {
      this.norwaySelected = false;
      this.addedRegions = [];
      this.resetRegionTypeSelector();
    }
  },
  computed: {
    showAddMoreArea() {
      return !this.norwaySelected && (this.enableShowArea || this.addedRegions.length == 0);
    },
    showAddMoreButton() {
      if (this.showAddMoreArea) return this.selectedRegions.length > 0;
      return (
        !this.showAddMoreArea ||
        this.selectedRegions.length > 0 ||
          (this.addedRegions.length > 0 && this.selectedRegions.length == 0)
      );
    },
    filteredRegionTypes() {
      if (!this.regionTypes) return [];
      const addedTypes = this.addedRegionTypes;
      const filtered = this.regionTypes.filter(
        region =>
          addedTypes.length == 0 || addedTypes.indexOf(region.regionType) < 0
      );
      return filtered;
    },
    visibleRegionTypes() {
      return this.regionTypes;
    },
    addedRegionTypes() {
      if (this.norwaySelected) return "0";
      return this.addedRegions.map(region => region.regionType).unique();
    },
    visibleRegions() {
      if (
        !this.selectedRegionType.regionType ||
        this.selectedRegionType.regionType === "0" ||
        this.selectedRegionType.regionType === "-1"
      ) {
        return [];
      }
      return this.$store.getters.avalancheRegions.filter(
        region => region.regionType === this.selectedRegionType.regionType
      );
    },
    disableCompleteButton() {
      if (this.allRegionsSelected) return false;
      if (this.selectedRegions.length > 0) return false;
      if (this.selectedRegionType.regionType === "0") return false; // Hele norge
      return true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card-body {
  background-color: rgba(4, 73, 98, 0.035);
}

.region-select {
  height: 36px;
  border: 1px solid #979797;
  border-radius: 2px;
  font-size: 16px;
  line-height: 140%;
  color: #444444;
  width: 80%;
  margin-bottom: 16px;

  padding-left: 8px;
  cursor: pointer;
}

option.one-bold:nth-child(2) {
  font-weight: bold;
}
option.two-bold:nth-child(2) {
  font-weight: bold;
}
option.two-bold:nth-child(3) {
  font-weight: bold;
}

.wrapper {
  margin: 0;
  padding: 0;
}
</style>
